import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../CartContext';
import { useSelector } from 'react-redux';

const StripeReturn = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { clearCart } = useCart();
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);

  const verifyPaymentAndCreateOrder = async (sessionId) => {
    try {
      const statusResponse = await fetch(`${process.env.REACT_APP_STORE_API_URL}/session-status?session_id=${sessionId}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Api-Name": "store-api",
            "Authorization": `Bearer ${token}`
          }
        }
      );
      const statusData = await statusResponse.json();

      if (statusData.status === 'complete') {
        const storedCartItems = JSON.parse(localStorage.getItem('pendingOrderItems') || '[]');
        
        const orderData = {
          user_id: user.id,
          category: 'groceries',
          items: storedCartItems,
          subtotal: storedCartItems.reduce((total, item) => total + item.price * item.quantity, 0),
          tax: 0,
          shipping: 0,
          total: storedCartItems.reduce((total, item) => total + item.price * item.quantity, 0),
          shipping_address: statusData.shipping_address,
          payment_method: statusData.payment_method,
          payment_intent: statusData.payment_intent,
          payment_method_configuration_details: statusData.payment_method_configuration_details,
        };

        const orderResponse = await fetch(`${process.env.REACT_APP_STORE_API_URL}/create-order`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            "Api-Name": "store-api",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify(orderData),
        });

        const orderResult = await orderResponse.json();

        if (orderResult.order_id) {
          localStorage.removeItem('pendingOrderItems');
          clearCart();
          navigate(`/store/groceries/order-confirmation?order_id=${orderResult.order_id}`);
        } else {
          throw new Error('Failed to create order');
        }
      } else {
        throw new Error('Payment not completed');
      }
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      navigate('/error');
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sessionId = queryParams.get('session_id');

    if (sessionId) {
      verifyPaymentAndCreateOrder(sessionId);
    } else {
      setLoading(false);
      navigate('/error');
    }
  }, [navigate, location]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-2xl font-semibold mb-4">Processing your order...</h2>
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
        </div>
      </div>
    );
  }

  return null;
};

export default StripeReturn;
